import Box from "@mui/material/Box";
import BoxContent from "shared/ui/BoxContent";
import PageTitle from "shared/ui/PageTitle";
import {useRouteMatch} from "utils/functions";
import {Link, useLocation, useNavigate} from "react-router-dom";
import GenericButton from "shared/ui/GenericButton";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Users from "../components/Users";
import React from "react";

const Teachers = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const currentTab = useRouteMatch(["/profesori", "/profesori/arhiva"]);

    return (
        <Box>
            <PageTitle
                actions={
                    <GenericButton
                        type="add"
                        onClick={() => {
                            navigate(`/profesori/adauga`);
                        }}
                    />
                }
            >
                Profesori
            </PageTitle>

            <BoxContent>
                <Box sx={{width: "100%"}}>
                    <Box mb={2} sx={{borderBottom: 1, borderColor: "divider"}}>
                        <Tabs
                            value={currentTab}
                            sx={{
                                "& .MuiTabs-flexContainer": {
                                    flexWrap: "wrap",
                                },
                            }}
                        >
                            <Tab label="Profesori activi" value="/profesori" to="/profesori" component={Link}/>
                            <Tab
                                label="Profesori arhivați"
                                value="/profesori/arhiva"
                                to="/profesori/arhiva"
                                component={Link}
                            />
                        </Tabs>
                    </Box>
                    {location.pathname === "/profesori" && <Users type="teachers" isArchived={false}/>}
                    {location.pathname === "/profesori/arhiva" && <Users type="teachers" isArchived={true}/>}
                </Box>
            </BoxContent>
        </Box>
    );
};

export default Teachers;
